import React, { useContext } from 'react';
import dataJson from '../../data/data.json';
import { FinancialStatusContext } from '../context/financial-status-context';
import { JsonData, StepData } from '../types';
import { styles } from '../../../styles';

type ComponentProps = {
	currentStep: keyof JsonData; // Use keyof JsonData to restrict step to valid keys
	value: string;
};

export default function Label({ currentStep, value }: ComponentProps) {
	const financialContext = useContext(FinancialStatusContext);
	const data: JsonData = dataJson as JsonData;

	// Retrieve the step data
	const currentStepData = data[currentStep];

	// Function to find the question within the step data
	const findQuestion = (stepData: StepData, key: string) => {
		if (stepData.questions) {
			const question = stepData.questions.find((q) => q.key === key);
			if (question) return question;
		}
		if (stepData.radioQuestions) {
			const question = stepData.radioQuestions.find((q) => q.key === key);
			if (question) return question;
		}
		return null;
	};

	// Find the question
	const question = findQuestion(currentStepData, value);

	if (!question) {
		console.error(`Question with key ${value} not found in step ${currentStep}.`);
		return null;
	}

	// Get the text based on the current language
	const text = question[financialContext.language];

	return (
		<label className={styles.label} htmlFor={value}>
			{text}
		</label>
	);
}
